import * as ReactRedux from 'react-redux';
import IntenalServerErrorComponent from './internal.server.error.component';
import { AppState } from '../app/app.types';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    toDashboard: () => {
      return dispatch(push(paths.dashboard));
    },
    toAdminDashboard: () => {
      return dispatch(push(paths.adminDashboard));
    }
  };
};

const mapStateToProps = (appState: AppState) => {
  return {
    authState: appState.authState,
    signupState: appState.signupState,
    adminState: appState.adminState
  };
};

const NotFound: React.ComponentClass<{}> = 
  ReactRedux.connect(mapStateToProps, mapDispatchToProps)(IntenalServerErrorComponent);

export default NotFound;



// WEBPACK FOOTER //
// ./src/commons/internal.server.error.tsx